<template>
  <div>
    <v-main>
      <v-container fluid>
        <!-- <app-headline :title="title + ' ของ ' + this.$username" /> -->
        <v-row>
          <v-col>
            <v-card
              class="py-3"
              :class="$vuetify.breakpoint.smAndUp ? 'px-8' : 'px-5'"
            >
              <v-container>
                <app-headline title="ข้อมูลส่วนตัว" />
                <v-divider class="mt-2"></v-divider>
                <data-display :data="userProfile"></data-display>
              </v-container>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-card
              class="py-3"
              :class="$vuetify.breakpoint.smAndUp ? 'px-8' : 'px-0'"
            >
              <v-container>
                <app-headline
                  :class="$vuetify.breakpoint.smAndUp ? 'px-0' : 'px-5'"
                  title="ข้อมูลเพิ่มเติม"
                />
                <v-divider
                  :class="$vuetify.breakpoint.smAndUp ? 'mx-0' : 'mx-5'"
                  class="mt-2"
                ></v-divider>
                <add-stepper type="Current"></add-stepper>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import DataDisplay from '@/components/reqcer/DataDisplay.vue'
import AddStepper from '@/components/reqcer/user/AddStepper.vue'

export default {
  components: {
    DataDisplay,
    AddStepper
  },
  data() {
    return {
      title: 'คำขอ',
      userProfile: []
    }
  },
  computed: {},

  mounted() {
    this.initialInfo()
  },
  methods: {
    async initialInfo() {
      const res = await this.apiGetInfo()
      const info = res.data.data || {}
      const lang = this.$lang
      // console.log(res)

      this.userProfile = [
        {
          id: 'nameSurnameTha',
          name: 'ชื่อ-นามสกุล',
          value: info.nameSurnameTha ? info.nameSurnameTha : this.$t('noData')
        },
        {
          id: 'nameSurnameEng',
          name: 'ชื่อ-นามสกุล (อังกฤษ)',
          value: info.nameSurnameEng ? info.nameSurnameEng : this.$t('noData')
        },
        {
          id: 'employeeTypeName',
          name: 'ประเภทบุคลากร',
          value: info[`employeeTypeName${lang}`]
            ? info[`employeeTypeName${lang}`]
            : this.$t('noData')
        },
        {
          id: 'positionName',
          name: 'ตำแหน่ง',
          value: info[`positionName${lang}`]
            ? info[`positionName${lang}`]
            : this.$t('noData')
        },
        {
          id: 'level',
          name: 'ระดับ',
          value: info[`level${lang}`] ? info[`level${lang}`] : '-'
        },
        {
          id: 'salary',
          name: 'เงินเดือน',
          value: info.salary
            ? this.$currencyFilter(info.salary) + ' บาท'
            : this.$t('noData')
        },

        {
          id: 'organizationFullName',
          name: 'สังกัดหน่วยงานปฏิบัติงานจริง',
          value: info[`organizationFullName${lang}`]
            ? info[`organizationFullName${lang}`]
            : this.$t('noData')
        }
      ]

      if (info.positionExecNameTha) {
        this.userProfile.push({
          id: 'positionExecName',
          name: 'ตำแหน่งบริหาร',
          value: info[`positionExecName${lang}`]
            ? info[`positionExecName${lang}`]
            : this.$t('noData')
        })
        this.userProfile.push({
          id: 'execSalary',
          name: 'ค่าตอบแทนบริหาร',
          value: info.execSalary ? info.execSalary : this.$t('noData')
        })
      }

      this.userProfile.push({
        id: 'dateStartWork',
        name: 'วันที่เริ่มทำงาน',
        value: info.dateStartWork
          ? this.$dateFormatByLang(info.dateStartWork)
          : this.$t('noData')
      })
      this.userProfile.push({
        id: 'nameSurnameTha',
        name: 'วันที่เปลี่ยนสถานภาพ',
        value: info.dateChangeWork
          ? this.$dateFormatByLang(info.dateChangeWork)
          : this.$t('noData')
      })
    },

    async apiGetInfo() {
      try {
        const res = await this.$store.dispatch('reqCer/getBasicInfo')
        return res
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
